import { render, staticRenderFns } from "./DeactivatingCompleteBasicUser.vue?vue&type=template&id=3aab5ec4&scoped=true&"
import script from "./DeactivatingCompleteBasicUser.vue?vue&type=script&lang=js&"
export * from "./DeactivatingCompleteBasicUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivatingCompleteBasicUser.vue?vue&type=style&index=0&id=3aab5ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aab5ec4",
  null
  
)

export default component.exports